module.exports = __webpack_public_path__ + "static/media/background2.ef27fd7b.jpg";